// EmployerPartnerships.js
import React from 'react';
import { motion } from 'framer-motion';

const EmployerPartnerships = () => {
  const countries = [
    { name: 'United Kingdom', image: 'uk.jpg' },
    { name: 'Ireland', image: 'ireland.jpg' },
    { name: 'Canada', image: 'canada.jpg' },
    { name: 'Australia', image: 'australia.jpg' }
  ];

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-primary mb-4">
            Where Our Employer Partners Are
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-3xl mx-auto mb-8">
            Ivipass has working relationships with employers and recruitment partners in several main destinations:
          </p>
        </motion.div>

        {/* Countries Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
            {countries.map((country, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.3 + (index * 0.1) }}
                className="bg-white p-6 text-center hover:shadow-md transition-all border border-gray-200"
              >
                <div className="w-12 h-12 mx-auto mb-3 rounded-full overflow-hidden shadow-md">
                  <img 
                    src={require(`../../assets/countries/${country.image}`)} 
                    alt={country.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-sm font-normal text-gray-700">
                  {country.name}
                </div>
              </motion.div>
            ))}
          </div>

          {/* Additional Markets Note */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.7 }}
            className="text-center mb-12"
          >
            <p className="text-gray-600 text-sm font-light">
              Other markets are covered on a selective basis
            </p>
          </motion.div>
        </motion.div>

        {/* Interview Access Info */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="bg-white p-8 rounded-lg border border-gray-200"
        >
          <div className="max-w-3xl mx-auto">
            <h3 className="text-lg font-semibold text-primary mb-4 text-center">
              How Interview Access Works
            </h3>
            <p className="text-gray-600 text-sm font-light leading-relaxed text-center">
              These relationships are how we open interview access for candidates who meet the criteria set by a role and by the employer behind it. How much is available at any point comes down to what our partners are recruiting for and whether a candidate is ready to be put forward.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EmployerPartnerships;
